(function ($) {
    var dot = '.';

    var itemClass = 'subnav__item';
    var linkClass = 'subnav__link';
    var toggleClass = 'subnav__toggle-link';
    var subListClass = 'subnav__sub-list';

    var itemClassActive = itemClass + '--active';
    var toggleClassVisible = toggleClass + '--visible';

    // Show and hide the second level lists in the subnav by clicking on arrow
    // links or buttons to the side of each first level link.
    $(function () {
        var subLists = $(dot + subListClass);

        subLists.each(function (subListIndex, subListNode) {
            var subList = $(subListNode);
            var item = subList.parent();
            var link = item.find(dot + linkClass);
            var toggle = item.find('> ' + dot + toggleClass);

            if (toggle.length === 0) {
                toggle = $('<a href="#" class="' + toggleClass + '"><svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24"><path d="M7.41 8.58L12 13.17l4.59-4.59L18 10l-6 6-6-6 1.41-1.42z"/></svg> <span class="screen-reader-text">show/hide links</span></a>');
                link.after(toggle);
            }

            toggle.on('click', function (e) {
                e.preventDefault();
                e.stopPropagation();

                subList.slideToggle().promise().done(function () {
                    toggle.toggleClass(toggleClassVisible, subList.is(':visible'));
                });
            });

            if (item.hasClass(itemClassActive)) {
                toggle.addClass(toggleClassVisible);
            } else {
                subList.hide();
            }
        });
    });
})(jQuery);
